import React, { useState } from 'react';
import { AppointmentType as DBAppointmentType } from '@prisma/client';
import AppointmentType from './AppointmentType';
import TimeBlockForm from '../availability/TimeBlockForm';
import AppointmentForm, { CreateUpdateArgs } from './AppointmentForm';
import useCalendarSelectedAppointment from '../../hooks/appointments/useCalendarSelectedAppointment';
import useInitialAppointmentForm from '../../hooks/appointments/useInitialAppointmentForm';

interface Props {
  onClose: () => void;
  onCreateUpdateSuccess?: (args: CreateUpdateArgs) => void | Promise<void>;
  setShouldScrollToTop?: React.Dispatch<React.SetStateAction<boolean>>;
}

function CalendarNewForm({
  onClose,
  onCreateUpdateSuccess,
  setShouldScrollToTop,
}: Props) {
  const { selectedAppointment } = useCalendarSelectedAppointment();
  const { initialAppointmentForm } = useInitialAppointmentForm();

  const [appointmentType, setAppointmentType] = useState<
    DBAppointmentType | 'TIME_BLOCK' | 'BOOKING_LINK' | undefined
  >(initialAppointmentForm ? 'NEW_APPOINTMENT' : undefined);

  return (
    <>
      {!appointmentType && !selectedAppointment && (
        <AppointmentType
          value={appointmentType}
          setFieldValue={setAppointmentType}
        />
      )}
      {appointmentType === 'TIME_BLOCK' && <TimeBlockForm onClose={onClose} />}
      {appointmentType !== 'TIME_BLOCK' &&
        (appointmentType || selectedAppointment) && (
          <AppointmentForm
            onClose={onClose}
            onCreateUpdateSuccess={onCreateUpdateSuccess}
            setShouldScrollToTop={setShouldScrollToTop}
            appointmentType={
              appointmentType === 'BOOKING_LINK'
                ? 'NEW_APPOINTMENT'
                : appointmentType
            }
            isBookingLink={appointmentType === 'BOOKING_LINK'}
          />
        )}
    </>
  );
}

export default CalendarNewForm;
